import React from "react";
import "./WidgetBar.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as uiActionCreators } from "../../../../actions/uiActions";
import { actionCreators as widgetConfigActionCreators } from "../../../../actions/widgetConfigActions";

import WidgetBarItem from "./WidgetBarItem";
import { withTranslation } from 'react-i18next';

class WidgetBar extends React.PureComponent {
  onAddWiget(widgettype) {
    let { addWidgetToDashboard } = this.props;
    addWidgetToDashboard(widgettype);
  }

  render() {
    let { startDrag, addWidgetToDashboard, t } = this.props;
    return (
      <div className="widgetbar">
        <div className="widgetbar-heading">Widgets</div>
        <div className="widgetbar-itemwrapper">
        <WidgetBarItem
          startDrag={startDrag}
          addWidgetToDashboard={addWidgetToDashboard}
          widgetType="simplenumeric"
          displayName="Text"
        />
        <WidgetBarItem
          startDrag={startDrag}
          addWidgetToDashboard={addWidgetToDashboard}
          widgetType="radialgauge"
          displayName={t('wname_radialgauge')}
        />
        <WidgetBarItem
          startDrag={startDrag}
          addWidgetToDashboard={addWidgetToDashboard}
          widgetType="lineargauge"
          displayName={t('wname_lineargauge')}
        />
        <WidgetBarItem
          startDrag={startDrag}
          addWidgetToDashboard={addWidgetToDashboard}
          widgetType="linechart"
          displayName={t('wname_linechart')}
        />
        <WidgetBarItem
          startDrag={startDrag}
          addWidgetToDashboard={addWidgetToDashboard}
          widgetType="imageview"
          displayName={t('wname_imageview')}
        />        
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...widgetConfigActionCreators, ...uiActionCreators },
    dispatch
  );
}

const ConnectedWidgetBar = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(WidgetBar));

export default ConnectedWidgetBar;
